<ul class="breadcrumb">
  <li><a [routerLink]="['/home']"><span class="color-soft-grey-axial">ESTÁS EN </span>Inicio</a></li>
  <li><i class="pi pi-angle-right"></i></li>
  <li *ngIf="isViewInit"><a [routerLink]="['/transactions/'+transaction_type_id]">{{view.getEntityBaseName(true)}}</a></li>
  <li *ngIf="transaction_type_id==null"><a [routerLink]="['/transactions']">Transacciones</a></li>
</ul>
<app-view *ngIf="transaction_type_id==null" #view [code]="'transactions.list'" [model]="transactionsFilters" (onEvent)="onEvent($event)"></app-view>
<app-view *ngIf="transaction_type_id!=null" #view [code]="'transactions.list'+transaction_type_id" [model]="transactionsFilters" (onEvent)="onEvent($event)"></app-view>
